// @flow
import { Component } from 'react';
import Cookies from 'universal-cookie';
import isEmpty from 'lodash/isEmpty';
import isEqual from 'react-fast-compare';

const cookie = new Cookies();

type Props = $ReadOnly<{|
    authToken: string,
    mainhostLogin: any,
    recordAnalyticsForIdentify: Function,
    userData: any,
    userLoggedIn: boolean,
|}>;

export default class Auth extends Component<Props> {
    componentDidUpdate(prevProps: Props) {
        if (!isEqual(prevProps.userData, this.props.userData) && !isEmpty(this.props.userData)) {
            this.props.recordAnalyticsForIdentify({ bidder: this.props.userData });
        }

        const {
            authToken: nextAuthToken,
            mainhostLogin: nextMainhostLogin,
            userLoggedIn: nextUserLoggedIn,
        } = this.props;

        if (
            (!prevProps.authToken && nextAuthToken) ||
            (Boolean(nextAuthToken) && prevProps.authToken !== nextAuthToken)
        ) {
            const expires = this.getExp(nextAuthToken);

            this.setAuthCookie(nextAuthToken, expires);
            if (nextMainhostLogin.authVerify) {
                this.setMainhostCookies(nextMainhostLogin, expires);
            }
        }

        if (prevProps.userLoggedIn && !nextUserLoggedIn) {
            this.unsetCookies();
        }
    }

    getExp = (token: string = '') => {
        const splitToken = token.split('.');
        if (splitToken.length < 2) {
            console.warn('Failed to decode JWT expiration');
            return;
        }
        try {
            if (!atob(splitToken[1])) {
                return;
            }
            const payload = JSON.parse(atob(splitToken[1]));
            return new Date(payload.exp * 1000);
        } catch (e) {
            console.warn('Failed to decode JWT expiration', e);
            return new Date(0);
        }
    };

    setAuthCookie = (authToken: string, expires: any) => {
        cookie.set('bidder-auth', authToken, {
            domain: '.liveauctioneers.com',
            expires,
            path: '/',
        });
    };

    setMainhostCookies = (mainhostLogin: any, expires: any) => {
        cookie.set('5Xq_name', mainhostLogin.authName, {
            domain: '.liveauctioneers.com',
            expires,
            path: '/',
        });
        cookie.set('5Xq_nuid', mainhostLogin.authNuid, {
            domain: '.liveauctioneers.com',
            expires,
            path: '/',
        });
        cookie.set('5Xq_nverify', mainhostLogin.authVerify, {
            domain: '.liveauctioneers.com',
            expires,
            path: '/',
        });
    };

    unsetCookies = () => {
        cookie.remove('auctioneer-auth', { domain: '.liveauctioneers.com', path: '/' });
        cookie.remove('bidder-auth', { domain: '.liveauctioneers.com', path: '/' });
        cookie.remove('5Xq_name', { domain: '.liveauctioneers.com', path: '/' });
        cookie.remove('5Xq_nuid', { domain: '.liveauctioneers.com', path: '/' });
        cookie.remove('5Xq_nverify', { domain: '.liveauctioneers.com', path: '/' });
    };

    render() {
        return null;
    }
}
